import { useQuery } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import extract from '@pepper/utils/src/function/extract'

import { KeywordLabel } from 'types/keyword'

type Props = {
  id: string
  companyId: string
  enabled: boolean
}

type ApiError = {
  response?: {
    data: {
      description: string
      status: 'failure'
    }
  }
}

const handleFetch = async (id: string, companyId: string) => {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/keywords/v2/suggestions/${id}`
  const response = await axios.get(url)
  return extract.data(response).data
}

export const useKeywordLabelling = ({ id, enabled, companyId }: Props) => {
  const { data, error, isLoading } = useQuery<KeywordLabel, ApiError>({
    queryKey: ['keyword-suggestion-label', id, companyId],
    queryFn: () => handleFetch(id, companyId),
    enabled,
  })
  return {
    data,
    isLoading,
    error: error?.response?.data?.description,
  }
}
